var content = (function (module) {
var css = { id: module.id, exports: {} };
(function (module) {
exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "\n@media screen and (max-width: 500px) {\n  div.all_standup {\n    padding-left: 8px;\n    width: 190%;\n    overflow: auto;\n    white-space: nowrap;\n  }\n}\n", "",{"version":3,"sources":["AllStandups.css"],"names":[],"mappings":";AACA;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,mBAAmB;EACrB;AACF","file":"AllStandups.css","sourcesContent":["\n@media screen and (max-width: 500px) {\n  div.all_standup {\n    padding-left: 8px;\n    width: 190%;\n    overflow: auto;\n    white-space: nowrap;\n  }\n}\n"]}]);


})(css);
return css.exports;
}) (module);
var loader = require("/home/ubuntu/trooprbot-ui/node_modules/antd-theme/lib/loadThemedStyles.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;